var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-screen-box"},[_c('div',{staticClass:"full-screen-container",style:(_vm.containerStyle)},[_vm._t("title",function(){return [_c('div',{staticClass:"title-box",style:(_vm.titleStyle)},[(_vm.title)?_c('span',{staticClass:"top-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e()])]}),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }